import {useAui} from '@assistant-ui/react';
import {IconButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {WBAgentChatHistoryPopover} from './chatHistory/WBAgentChatHistoryPopover';
import {useWBAgentContextStore} from './WBAgentContextStore';

export const WBAgentHeader = () => {
  const aui = useAui();
  const setOpen = useWBAgentContextStore(s => s.setOpen);
  const clearRuns = useWBAgentContextStore(s => s.clearRuns);
  const docked = useWBAgentContextStore(s => s.docked);
  const setDocked = useWBAgentContextStore(s => s.setDocked);

  const handleNewChat = useCallback(() => {
    aui.threads().switchToNewThread();
    clearRuns();
  }, [aui, clearRuns]);

  return (
    <div className="flex items-center justify-between border-b border-solid border-moon-250 px-16 py-12">
      <h2 className="text-xl font-semibold">W&B Agent</h2>
      <div>
        <IconButton
          variant="ghost"
          icon="compose"
          aria-label="new-chat"
          onClick={handleNewChat}
          tooltip={{
            children: 'Start new chat (clears current)',
          }}
        />
        <WBAgentChatHistoryPopover />
        <IconButton
          variant="ghost"
          icon={docked ? 'undock' : 'dock-arrow'} // To do: switch to dock-arrow and undock when core-ux PR is approved
          aria-label={docked ? 'undock chat' : 'dock chat'}
          onClick={() => setDocked(!docked)}
          tooltip={{
            children: docked ? 'Undock chat' : 'Dock chat',
          }}
        />
        <IconButton
          variant="ghost"
          icon="close"
          aria-label="close"
          onClick={() => setOpen(false)}
          tooltip={{
            children: 'Minimize',
          }}
        />
      </div>
    </div>
  );
};
